export const formatDistance = (dist: number) => {
    const km = Math.round(dist * 100) / 100;

    return `${km}`.replace('.', ',');
}